import { Components, Theme } from '@mui/material/styles';

export const flowInputLabel: Components<Theme>['MuiInputLabel'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      // remove pointer events to prevent blur and focus formControl
      pointerEvents: 'none',
      transition: 'inherit',
      color: 'inherit',
      [theme.breakpoints.up('xs')]: {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: '400',
      },
    }),
    filled: {
      transform: 'translate(12px, 18px) scale(1)',
      '&.MuiInputLabel-shrink': {
        transform: 'translate(12px, 7px) scale(0.75)',
      },
      '&.MuiInputLabel-sizeSmall': {
        transform: 'translate(12px, 13px) scale(1)',
        '&.MuiInputLabel-shrink': {
          transform: 'translate(12px, 7px) scale(0.75)',
        },
      },
      '&:has(+ .MuiInputBase-adornedStart .MuiInputAdornment-positionStart)': {
        transform: 'translate(44px, 18px) scale(1)',
        '&.MuiInputLabel-sizeSmall': {
          transform: 'translate(44px, 13px) scale(1);',
        },
        '&.MuiInputLabel-shrink': {
          transform: 'translate(44px, 7px) scale(0.75)',
        },
      },
    },
    outlined: {
      '&:has(+ .MuiInputBase-adornedStart .MuiInputAdornment-positionStart)': {
        transform: 'translate(44px, 16px) scale(1);',
        '&.MuiInputLabel-sizeSmall': {
          transform: 'translate(44px, 9px) scale(1);',
        },
        '&.MuiInputLabel-shrink': {
          transform: 'translate(14px, -9px) scale(0.75);',
        },
      },
    },
    standard: {
      '&:has(+ .MuiInputBase-adornedStart)': {
        transform: 'translate(32px, 20px) scale(1);',
        '&.MuiInputLabel-sizeSmall': {
          transform: 'translate(32px, 18px) scale(1);',
        },
        '&.MuiInputLabel-shrink': {
          transform: 'translate(0, -1.5px) scale(0.75)',
        },
      },
    },
  },
};
